import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

@Component({
	selector: 'app-store-profile-information',
	templateUrl: './store-profile-information.component.html',
	styleUrls: ['./store-profile-information.component.scss'],
})
export class StoreProfileInformationComponent implements OnInit {
	editMode: boolean = false
	storeInfoForm: FormGroup = new FormGroup({})
	constructor() {}

	ngOnInit(): void {
		this.initForm()
	}

	initForm() {
		this.storeInfoForm = new FormGroup({
			physicalStore: new FormControl(false),
			expectedToHaveStore: new FormControl(false),
		})
	}
	getController(controlName: string) {
		return this.storeInfoForm.controls[controlName] as FormControl
	}
	changePhysicalStore(event: any) {
		if (!event.checked) {
			this.getController('storeBranches')?.setValue(false)
			this.getController('storeBranchesCount')?.setValue(null)
			this.storeInfoForm.removeControl('storeBranches')
			this.storeInfoForm.removeControl('commercialRegister')
			this.storeInfoForm.removeControl('storeBranchesCount')
		} else {
			this.storeInfoForm.addControl(
				'commercialRegister',
				new FormControl('', [
					Validators.required,

					Validators.minLength(10),
					Validators.maxLength(20),
				])
			)
			this.storeInfoForm.addControl('storeBranches', new FormControl(false))
		}
	}
	changeBranchCount(operation: string) {
		const currentCount = this.getController('storeBranchesCount').value

		if (operation === '+') {
			if (currentCount < 5) {
				if (currentCount === 0) {
					this.getController('storeBranchesCount').setValue(2)
				} else {
					this.getController('storeBranchesCount').setValue(currentCount + 1)
				}
			}
		} else if (operation === '-') {
			if (currentCount > 2) {
				this.getController('storeBranchesCount').setValue(currentCount - 1)
			}
		}
	}
	storeBranchesChange(event: any) {
		if (event.checked) {
			this.storeInfoForm.addControl(
				'storeBranchesCount',
				new FormControl(2, [Validators.min(2), Validators.required])
			)
		} else this.storeInfoForm.removeControl('storeBranchesCount')
	}
	expectedToHaveStore(event: any) {
		event?.checked
			? this.storeInfoForm.addControl(
					'expectedToHaveStore',
					new FormControl(event?.checked)
			  )
			: this.storeInfoForm.removeControl('expectedToHaveStore')
	}

	cancel() {
		this.storeInfoForm.reset()
		this.storeInfoForm.removeControl('storeBranches')
		this.storeInfoForm.removeControl('commercialRegister')
		this.storeInfoForm.removeControl('storeBranchesCount')

		// this.getController('storeBranchesCount').setValue(2)
	}
	isNumber(evt: any) {
		evt = evt ? evt : window.event
		var charCode = evt.which ? evt.which : evt.keyCode
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false
		}
		return true
	}
	submit() {
		console.log(this.storeInfoForm.getRawValue())
	}
}
